import React, {useEffect, useRef, useState} from 'react';
import {addPrefix} from "../../utils/UriUtil";
import {jsonResponseHandler} from '../../utils/FetchHelper'
import {useDispatch} from "react-redux";
import TSelectForm from "../../components/common/TSelectForm";
import classnames from "classnames";
import WindowEventHelper from "../../lib/WindowEventHelper";

const DEVICE_PC = "pc";
const DEVICE_MOBILE = "mobile";

function Loading({width, height}) {
  return <div className="preview_loading">
    <div className="wrap_loading" style={{width: `${width}px`, height: `${height}px`}}>
      <span className="ico_blog ico_loading"/>
      <p className="txt_loading">로딩중입니다</p>
    </div>
  </div>
}

const Preview = (props) => {

  /**
   * variables
   */
  const dispatch = useDispatch();
  const bodyClassName = 'scroll_hide';
  const useStrictMobile = window.Config.blog.useMobileSkin;
  const vendor = 'adfit';
  const bodyClass = document.body.classList;
  const pages = [
    {value: 'home', label: '홈'},
    {value: 'list', label: '리스트'},
    {value: 'entry', label: '글'},
  ];
  const pcPreset = {value: 'pc', label: 'PC', width: 1160, height: window.innerHeight - 72}
  const mobilePreset = {value: 'iphone-x', label: '아이폰 X', width: 375, height: 812}

  /**
   * state
   */
  const [device, setDevice] = useState(DEVICE_PC);
  const [prevDevice, setPrevDevice] = useState(null);
  const [prevPage, setPrevPage] = useState(pages[2].value);
  const [page, setPage] = useState(pages[2].value);
  const [isLoaded, setIsLoaded] = useState(false);
  const [entryId, setEntryId] = useState('');
  const [preset, setPreset] = useState(pcPreset);

  /**
   * ref
   * @type {React.MutableRefObject<null>}
   */
  const form = useRef(null);

  /**
   * props
   */
  const {showPreviewHandler, settings} = props;


  /**
   * remove body class
   * @param e
   */
  const popStateEventHandler = (e) => {
    history.pushState(null, null, location.href);
  }

  useEffect(() => {

    if (entryId === '')
      getEntryId();

    if (!bodyClass.contains(bodyClassName))
      bodyClass.add(bodyClassName);

    if (entryId) {
      form.current.submit();
    }

    /**
     * Prevent history back event
     */
    history.pushState(null, null, location.href);
    WindowEventHelper.add('popstate', popStateEventHandler);

  }, [device, page, entryId]);


  /**
   * 디바이스 변경
   * @param device
   */
  const changeDeviceHandler = (device) => {
    if (prevDevice !== device) {
      setPrevDevice(device);
      setIsLoaded(false);
      setDevice(device);
      setPreset(device === DEVICE_PC ? pcPreset : mobilePreset)
    }
  }

  /**
   * Page 변경
   * @param pageValue
   */
  const changeActivePageHandler = (pageValue) => {
    if (prevPage !== pageValue) {
      setPrevPage(pageValue);
      setIsLoaded(false);
      setPage(pageValue);
    }
  }

  const getEntryId = () => {
    fetch(addPrefix("/manage/posts.json?"), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {

        if (data.items)
          setEntryId(data.items[0].id);

      })
      .catch(e => {
        console.error(e);
      })
  }


  /**
   * close handler
   */
  const beforeClosePreviewHandler = () => {
    document.body.classList.remove(bodyClassName);
    showPreviewHandler();
  }

  /**
   * iframe onload handler
   */
  const iframeHandler = () => {
    history.pushState(null, null, location.href);
    setIsLoaded(true)
  }

  const emptyEvent = () => {
  }

  const isPC = device === DEVICE_PC;

  return (
    <div className="revenue_preview_layer">
      <div className="inner_revenue_preview">
        <div className="layer_head">
          <strong className="tit_layer">미리보기</strong>
          <ul className="preview_type">
            <li className={classnames({"on": isPC})}>
              <button className="btn_g" onClick={() => changeDeviceHandler(DEVICE_PC)}><span className="ico_blog ico_pc">PC</span></button>
            </li>
            <li className={classnames({"on": !isPC})}>
              <button className="btn_g" onClick={() => changeDeviceHandler(DEVICE_MOBILE)}><span className="ico_blog ico_mobile">모바일</span></button>
            </li>
            <li>
              <TSelectForm
                className={"opt_set"}
                items={pages}
                selected={page}
                onSelect={item => changeActivePageHandler(item.value)}
              />
            </li>
          </ul>
        </div>
        <div className="layer_body">
          {!isLoaded && <Loading width={preset.width} height={preset.height}/>}
          <form ref={form} action={"/manage/previewRevenue.php"} method={'post'} target={'rp_iframe'}>
            <input type={'hidden'} name={'revenueUseStrictMobile'} value={useStrictMobile} onChange={emptyEvent}/>
            <input type={'hidden'} name={'revenueVendor'} value={vendor} onChange={emptyEvent}/>
            <input type={'hidden'} name={'revenuePage'} value={page} onChange={emptyEvent}/>
            <input type={'hidden'} name={'revenueEntryId'} value={entryId} onChange={emptyEvent}/>
            <input type={'hidden'} name={'revenueDevice'} value={device} onChange={emptyEvent}/>
            <input type={'hidden'} name={'revenueSettings'} value={JSON.stringify(settings)} onChange={emptyEvent}/>
          </form>
          <iframe width={preset.width} height={preset.height} src={"/service/spinnerGray.html"} className="revenue_preview_iframe" name="rp_iframe" onLoad={iframeHandler}/>
        </div>
        <div className="layer_foot"/>
        <button className="btn_close" onClick={beforeClosePreviewHandler}><span className="ico_blog ico_close">닫기</span></button>
      </div>
    </div>
  );
};

export default Preview;
